import { config } from '../config/environment';

export interface ChartData {
  [key: string]: {
    data: any[];
    relevance: number;
    priority: number;
  };
}

export interface LLMContextResponse {
  success: boolean;
  message: string;
  data: {
    charts: ChartData;
    queryAnalysis: {
      topics: string[];
      chartTypes: string[];
      priority: string;
    };
    totalRelevantCharts: number;
  };
}

export interface ChartSummaryResponse {
  success: boolean;
  message: string;
  data: {
    totalCharts: number;
    chartTypes: string[];
    lastUpdated: string;
    status: string;
    summary: string;
  };
}

class ChartManagementService {
  private baseURL: string;

  constructor() {
    this.baseURL = config.apiBaseUrl;
  }

  async getChartsForLLMContext(userId: string, query: string): Promise<LLMContextResponse> {
    try {
      const response = await fetch(`${this.baseURL}/api/chart-management/llm-context`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId,
          query
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error getting charts for LLM context:', error);
      throw error;
    }
  }

  async getChartSummary(userId: string): Promise<ChartSummaryResponse> {
    try {
      const response = await fetch(`${this.baseURL}/api/chart-management/summary/${userId}`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error getting chart summary:', error);
      throw error;
    }
  }

  async generateCharts(userId: string, birthData: any): Promise<any> {
    try {
      const response = await fetch(`${this.baseURL}/api/chart-management/generate-charts`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId,
          birthData
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error generating charts:', error);
      throw error;
    }
  }

  async refreshCharts(userId: string): Promise<any> {
    try {
      const response = await fetch(`${this.baseURL}/api/chart-management/refresh-charts`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error refreshing charts:', error);
      throw error;
    }
  }

  async getSystemStatus(): Promise<any> {
    try {
      const response = await fetch(`${this.baseURL}/api/chart-management/system-status`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error getting system status:', error);
      throw error;
    }
  }
}

export const chartManagementService = new ChartManagementService();
export default ChartManagementService;
